"use client";

import dynamic from "next/dynamic";
import LoadingFullPage from "@/components/indicators/LoadingFullPage";

const ComponentsPagesFaqWithTabs = dynamic(
  () => import("../components/ComponentsPagesFaqWithTabs"),
  { 
    ssr: false, 
    loading: () => <LoadingFullPage />
  }
);

export default function ComponentsPagesFaqWithTabsWrapper() {
  return <ComponentsPagesFaqWithTabs />;
}
